// extracted by mini-css-extract-plugin
export default {"bottomFooter":"stickyFooter_bottomFooter__4lhPv","nonScrollableFooter":"stickyFooter_nonScrollableFooter__WkAH8"};